<template>
<div class="chapter">
<div class="inner_page">
<div>
<h1 class="epigraph-title"><span><a href="#/toc#toc-epigraph"></a></span></h1><a id="p7"></a>
<table border="0" cellpadding="0" cellspacing="0" id="T0001" width="100%">
<caption></caption>
<colgroup>
<col width="10%"/>
<col width="90%"/>
</colgroup>
<tbody><tr>
<td valign="top"><p class="table">BOSS:</p></td>
<td valign="top"><p class="table">Are you married?</p></td>
</tr>
<tr>
<td valign="top"><p class="table">ZORBA:</p></td>
<td valign="top"><p class="table">Am I not a man?</p></td>
</tr>
<tr>
<td valign="top"><p class="table"></p></td>
<td valign="top"><p class="table">And is not a man stupid?</p></td>
</tr>
<tr>
<td valign="top"><p class="table"></p></td>
<td valign="top"><p class="table">I’m a man, so I’m married.</p></td>
</tr>
<tr>
<td valign="top"><p class="table"></p></td>
<td valign="top"><p class="table">Wife, children, house—everything.</p></td>
</tr>
<tr>
<td valign="top"><p class="table"></p></td>
<td valign="top"><p class="table">The full catastrophe.</p></td>
</tr>
</tbody></table>
<p class="attribution_p"><span>—<em>Zorba the Greek</em></span></p>
<a id="p8"></a></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?c3e4e0f4